import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

function AppHeader() {
  const location = useLocation();
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [menuOpen, setMenuOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const userType = user?.user_type || '';

  useEffect(() => {
    const handleResize = () => {
      const mobileView = window.innerWidth <= 768;
      setIsMobile(mobileView);

      if (!mobileView) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: 'Logout Confirmation',
      text: 'Are you sure you want to logout from the system?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Logout',
      cancelButtonText: 'Cancel',
      customClass: {
        popup: 'custom-swal-popup',
        title: 'custom-swal-title',
        htmlContainer: 'custom-swal-text',
        confirmButton: 'custom-swal-confirm',
        cancelButton: 'custom-swal-cancel',
      },
      buttonsStyling: false,
    });

    if (result.isConfirmed) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');

      await Swal.fire({
        title: 'Logged Out',
        text: 'You have been logged out successfully.',
        icon: 'success',
        timer: 1400,
        showConfirmButton: false,
        customClass: {
          popup: 'custom-swal-popup',
          title: 'custom-swal-title',
          htmlContainer: 'custom-swal-text',
        },
      });

      navigate('/login');
    }
  };

  const showEntryLink = userType === 'LOGISTICS';
  const showAdminLink = userType === 'ADMIN';

  return (
    <>
      <style>
        {`
          .custom-swal-popup {
            width: 420px;
            border-radius: 18px;
            padding: 28px 24px 24px;
            background: #ffffff;
            box-shadow: 0 20px 45px rgba(15, 23, 42, 0.16);
            border: 1px solid #e5e7eb;
            font-family: Arial, sans-serif;
          }

          .custom-swal-title {
            font-size: 24px;
            font-weight: 700;
            color: #111827;
            margin-bottom: 8px;
          }

          .custom-swal-text {
            font-size: 15px;
            line-height: 1.6;
            color: #6b7280;
            margin-top: 4px;
            margin-bottom: 22px;
          }

          .custom-swal-confirm {
            min-width: 130px;
            height: 44px;
            border: none;
            border-radius: 10px;
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: #ffffff;
            font-size: 14px;
            font-weight: 600;
            padding: 0 20px;
            cursor: pointer;
            margin-right: 10px;
          }

          .custom-swal-cancel {
            min-width: 110px;
            height: 44px;
            border: 1px solid #d1d5db;
            border-radius: 10px;
            background: #ffffff;
            color: #374151;
            font-size: 14px;
            font-weight: 600;
            padding: 0 20px;
            cursor: pointer;
          }
        `}
      </style>

      <header
        style={{
          ...headerStyle,
          ...(isMobile ? mobileHeaderStyle : {}),
        }}
      >
        <div style={leftSectionStyle}>
          <div style={brandWrapStyle}>
            <div style={brandBadgeStyle}>NH</div>

            <div>
              <div style={brandStyle}>Vials Tracking</div>
              <div style={subBrandStyle}>Logistics Management System</div>
            </div>
          </div>
        </div>

        {isMobile ? (
          <div style={mobileRightStyle}>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              style={menuButtonStyle}
            >
              ☰
            </button>
          </div>
        ) : (
          <div style={desktopNavWrapperStyle}>
            <div style={navStyle}>
              {showEntryLink && (
                <Link
                  to="/"
                  style={{
                    ...linkStyle,
                    ...(location.pathname === '/' ? activeLinkStyle : {}),
                  }}
                >
                  Entry Page
                </Link>
              )}

              {showAdminLink && (
                <Link
                  to="/admin"
                  style={{
                    ...linkStyle,
                    ...(location.pathname === '/admin' ? activeLinkStyle : {}),
                  }}
                >
                  Dashboard
                </Link>
              )}
            {showAdminLink && (
              <Link
                to="/masters"
                style={{
                  ...linkStyle,
                  ...(location.pathname === '/masters' ? activeLinkStyle : {}),
                }}
              >
                Masters
              </Link>
              )}
            </div>

            <div style={userSectionStyle}>
              {/* <div style={userInfoStyle}>
                <div style={userTypeBadgeStyle}>{userType || 'USER'}</div>
              </div> */}

              <button onClick={handleLogout} style={logoutButtonStyle}>
                Logout
              </button>
            </div>
          </div>
        )}
      </header>

      {isMobile && menuOpen && (
        <div style={mobileMenuStyle}>
          {/* <div style={mobileUserRowStyle}>
            <div style={userTypeBadgeStyle}>{userType || 'USER'}</div>
          </div> */}

          <div style={mobileNavLinksStyle}>
            {showEntryLink && (
              <Link
                to="/"
                onClick={() => setMenuOpen(false)}
                style={{
                  ...mobileLinkStyle,
                  ...(location.pathname === '/' ? mobileActiveLinkStyle : {}),
                }}
              >
                Entry Page
              </Link>
            )}

            {showAdminLink && (
              <Link
                to="/admin"
                onClick={() => setMenuOpen(false)}
                style={{
                  ...mobileLinkStyle,
                  ...(location.pathname === '/admin' ? mobileActiveLinkStyle : {}),
                }}
              >
                Dashboard
              </Link>
            )}
            {showAdminLink && (
              <Link
                to="/masters"
                onClick={() => setMenuOpen(false)}
                style={{
                  ...mobileLinkStyle,
                  ...(location.pathname === '/masters' ? mobileActiveLinkStyle : {}),
                }}
              >
                Master Page
              </Link>
            )}

            <button
              onClick={() => {
                setMenuOpen(false);
                handleLogout();
              }}
              style={mobileLogoutButtonStyle}
            >
              Logout
            </button>
          </div>
        </div>
      )}
    </>
  );
}

const headerStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 28px',
  background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
  color: '#ffffff',
  boxSizing: 'border-box',
  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.18)',
  position: 'sticky',
  top: 0,
  zIndex: 1000,
};

const mobileHeaderStyle = {
  padding: '14px 16px',
};

const leftSectionStyle = {
  display: 'flex',
  alignItems: 'center',
};

const brandWrapStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
};

const brandBadgeStyle = {
  width: '42px',
  height: '42px',
  borderRadius: '12px',
  background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: '700',
  fontSize: '14px',
  boxShadow: '0 8px 20px rgba(37, 99, 235, 0.32)',
};

const brandStyle = {
  fontSize: '20px',
  fontWeight: '700',
  lineHeight: '1.2',
};

const subBrandStyle = {
  fontSize: '12px',
  color: 'rgba(255,255,255,0.72)',
  marginTop: '2px',
};

const desktopNavWrapperStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '18px',
};

const navStyle = {
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
};

const linkStyle = {
  fontFamily: '"Mulish", sans-serif',
  textDecoration: 'none',
  color: '#e5e7eb',
  padding: '10px 16px',
  borderRadius: '12px',
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.08)',
  fontSize: '14px',
  fontWeight: '600',
  transition: 'all 0.3s ease',
};

const activeLinkStyle = {
  background: '#ffffff',
  color: '#0f172a',
  border: '1px solid #ffffff',
  boxShadow: '0 8px 18px rgba(255,255,255,0.12)',
};

const userSectionStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
};

const userInfoStyle = {
  display: 'flex',
  alignItems: 'center',
};

const userTypeBadgeStyle = {
  padding: '8px 12px',
  borderRadius: '999px',
  background: 'rgba(255,255,255,0.1)',
  border: '1px solid rgba(255,255,255,0.12)',
  fontSize: '12px',
  fontWeight: '700',
  letterSpacing: '0.5px',
  color: '#ffffff',
};

const logoutButtonStyle = {
  fontFamily: '"Mulish", sans-serif',
  border: 'none',
  background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  color: '#ffffff',
  padding: '10px 16px',
  borderRadius: '12px',
  fontSize: '14px',
  fontWeight: '700',
  cursor: 'pointer',
  boxShadow: '0 10px 20px rgba(220, 38, 38, 0.22)',
};

const mobileRightStyle = {
  display: 'flex',
  alignItems: 'center',
};

const menuButtonStyle = {
  width: '42px',
  height: '42px',
  borderRadius: '10px',
  border: '1px solid rgba(255,255,255,0.12)',
  background: 'rgba(255,255,255,0.08)',
  color: '#ffffff',
  fontSize: '20px',
  cursor: 'pointer',
};

const mobileMenuStyle = {
  background: '#ffffff',
  borderBottomLeftRadius: '18px',
  borderBottomRightRadius: '18px',
  boxShadow: '0 14px 34px rgba(15, 23, 42, 0.12)',
  padding: '14px 16px 18px',
  marginBottom: '16px',
};

const mobileUserRowStyle = {
  marginBottom: '12px',
};

const mobileNavLinksStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

const mobileLinkStyle = {
  fontFamily: '"Mulish", sans-serif',
  textDecoration: 'none',
  color: '#1f2937',
  padding: '12px 14px',
  borderRadius: '12px',
  background: '#f8fafc',
  border: '1px solid #e5e7eb',
  fontSize: '14px',
  fontWeight: '600',
};

const mobileActiveLinkStyle = {
  background: '#eff6ff',
  color: '#1d4ed8',
  border: '1px solid #bfdbfe',
};

const mobileLogoutButtonStyle = {
  fontFamily: '"Mulish", sans-serif',
  border: 'none',
  background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  color: '#ffffff',
  padding: '12px 14px',
  borderRadius: '12px',
  fontSize: '14px',
  fontWeight: '700',
  cursor: 'pointer',
};

export default AppHeader;